/* eslint-disable react/no-array-index-key */
import React, { useRef, useMemo, useCallback } from 'react';
import { pipe, filter, complement, propEq } from 'ramda';
import PropTypes from 'prop-types';

import { useAsyncState } from 'utils/useAsyncState';
import { ID, FILE_ID, NAME, ORIGINAL_NAME, FILE, FORM } from 'store/planning';
import ImagesReview from 'components/ImagesReview';
import Spinner from 'components/FullScreenSpinner';

import Item from './Item';
import { Container, ReadModeWrapper, NoDocuments, WaitItem, SpinnerWrap, Label } from './styles';

const MultiImage = ({ values, waiting, updateValues, ward, saveMedia }) => {
  const ref = useRef();
  const [imagePath, setImagePath] = useAsyncState();
  const files = useMemo(() => values.map(({ [FILE]: file }) => file), [values]);

  const closeFile = useCallback(() => setImagePath(), [setImagePath]);
  const removeMedia = useCallback((id) => pipe(filter(complement(propEq(id, ID))), updateValues)(values), [updateValues, values]);

  if (values.length === 0 && waiting.length === 0) {
    return (
      <ReadModeWrapper ref={ref} className="droppable_element" data-ward={ward}>
        <NoDocuments>Noch keine Dokumente vorhanden</NoDocuments>
      </ReadModeWrapper>
    );
  }

  return (
    <Container ref={ref} className="droppable_element" data-ward={ward}>
      {values.map(({ [ID]: id, [FILE]: fileData, [FORM]: form }) => (
        <Item
          key={id}
          ref={ref}
          id={id}
          fileData={fileData}
          form={form}
          setImagePath={setImagePath}
          saveMedia={saveMedia}
          removeMedia={removeMedia}
        />
      ))}
      {waiting.map((name, i) => (
        <WaitItem key={name + i}>
          <SpinnerWrap>
            <Spinner height="100%" />
          </SpinnerWrap>
          <Label>{name}</Label>
        </WaitItem>
      ))}
      {imagePath && <ImagesReview currentImage={imagePath} images={files} onClose={closeFile} />}
    </Container>
  );
};

MultiImage.propTypes = {
  values: PropTypes.arrayOf(
    PropTypes.shape({
      [ID]: PropTypes.string,
      [FILE]: PropTypes.shape({
        [FILE_ID]: PropTypes.string.isRequired,
        [NAME]: PropTypes.string.isRequired,
        [ORIGINAL_NAME]: PropTypes.string.isRequired,
      }).isRequired,
      [FORM]: PropTypes.shape({}),
    })
  ).isRequired,
  waiting: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  updateValues: PropTypes.func.isRequired,
  ward: PropTypes.string.isRequired,
  saveMedia: PropTypes.func.isRequired,
};

export default MultiImage;
